module.exports = __webpack_public_path__ + "img/corrigendum_header.b1c4ddeb.png";